require('./RAAccordionHeader.scss');
// @ commons
const OKPillSelectors = require('components/commons/OKPillSelectors/OKPillSelectors');
const {
    OKCollapsingToggler,
} = require('commonsComponents/OKCollapsingToggler');
const { OKLink } = require('commonsComponents/OKLink');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const classnames = require('classnames');

class RAAccordionHeader extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(newValue) {
        const { selectAccordionButton, rowId } = this.props;
        selectAccordionButton(rowId, newValue);
    }

    handleClick() {
        const { disabled, rowId } = this.props;
        if (!disabled) {
            this.props.onAccordionClick(rowId);
        }
    }

    render() {
        const {
            pillsConfig,
            description,
            isExpanded,
            icon,
            togglerText,
            selectedOption,
        } = this.props;

        const items = pillsConfig.map(item => ({
            text: item.label,
            value: item.id,
        }));

        const selectedValues = items.map(({ value }) => {
            if (selectedOption === value) return value;
        });

        const currentClassname = classnames('ra-accrodion-header', {
            'ra-accrodion-header--is-expanded': isExpanded,
        });

        const togglerClass = classnames(
            'ra-accrodion-header__columns__title--toggler',
            {
                'ra-accrodion-header__columns__title--toggler-hidden': isExpanded,
            },
        );

        const iconClass = `ra-accrodion-header__icon ${icon}`;

        return (
            <div className={currentClassname}>
                <div className="ra-accrodion-header__content">
                    <div className="ra-accrodion-header__columns__icon">
                        <i className={iconClass} />
                    </div>
                    <div className="ra-accrodion-header__columns__title">
                        <div className="ra-accrodion-header__columns__title--text">
                            {description}
                        </div>
                        <div
                            className={togglerClass}
                            onClick={this.handleClick}
                        >
                            <OKLink modifier="emphasize">{togglerText}</OKLink>
                            <OKCollapsingToggler
                                isIconSecondary={true}
                                isIconFixed={true}
                                isExpanded={false}
                            />
                        </div>
                    </div>

                    <div className="ra-accrodion-header__columns__pills">
                        <OKPillSelectors
                            items={items}
                            onSelectionChange={this.handleChange}
                            selectedValues={selectedValues}
                            externalHandling
                        />
                    </div>
                </div>
            </div>
        );
    }
}

RAAccordionHeader.propTypes = {
    rowId: PropTypes.string.isRequired,
    pillsConfig: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    isExpanded: PropTypes.bool,
    description: PropTypes.string,
    selectedOption: PropTypes.string,
    selectAccordionButton: PropTypes.func.isRequired,
    togglerText: PropTypes.string.isRequired,
    onAccordionClick: PropTypes.func,
};

module.exports = RAAccordionHeader;
